var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('notifications',{attrs:{"group":"ConveyNotification","position":"bottom left","width":_vm.notificationWidth},scopedSlots:_vm._u([{key:"body",fn:function(props){return [_c('div',{staticClass:"convey-notification d-flex border rounded bg-white-custom",class:{
        'border-success': props.item.type === 'success',
        'border-warning': props.item.type === 'warning',
        'border-danger': props.item.type === 'error',
        'border-info': props.item.type === 'info',
        'ml-3': !_vm.optimized,
        'ml-2': _vm.optimized,
        'mb-2': !_vm.optimized,
        'mb-1': _vm.optimized,
      }},[_c('div',{staticClass:"convey-notification--icon d-flex align-items-center justify-content-center",class:{
          'bg-success': props.item.type === 'success',
          'bg-warning': props.item.type === 'warning',
          'bg-danger': props.item.type === 'error',
          'bg-info': props.item.type === 'info',
          optimized: _vm.optimized,
        }},[(props.item.type === 'success')?_c('b-icon',{attrs:{"icon":"check-lg","scale":_vm.optimized ? 1 : 2}}):(props.item.type === 'warning')?_c('b-icon',{attrs:{"icon":"exclamation-triangle","scale":_vm.optimized ? 1 : 2}}):(props.item.type === 'error')?_c('b-icon',{attrs:{"icon":"exclamation-lg","scale":_vm.optimized ? 1 : 2}}):(props.item.type === 'info')?_c('b-icon',{attrs:{"icon":"info-lg","scale":_vm.optimized ? 1 : 2}}):_vm._e()],1),_c('div',{staticClass:"convey-notification--content",class:{
          optimized: _vm.optimized,
          'px-2': _vm.optimized,
          'py-2': _vm.optimized,
          general: !_vm.optimized,
          'px-3': !_vm.optimized,
          'py-3': !_vm.optimized,
        }},[(props.item.title)?_c('h5',{class:{
            'text-success': props.item.type === 'success',
            'text-warning': props.item.type === 'warning',
            'text-danger': props.item.type === 'error',
            'text-info': props.item.type === 'info',
          }},[_vm._v(" "+_vm._s(props.item.title)+" ")]):_vm._e(),_c('p',{staticClass:"mb-0 font-weight-medium",domProps:{"innerHTML":_vm._s(props.item.text)}})])])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }